// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    flex: 0 0 var(--sidebar-width);
    width: var(--sidebar-width);
    min-width: var(--sidebar-width);
    max-width: var(--sidebar-width);
    background: linear-gradient(180deg, #0f2036 0%, #15283c 60%, #17324e 100%);
    border-right: 1px solid rgba(255, 255, 255, 0.04);
}

@media (min-width: 992px) {
    .sidebar {
        position: sticky;
        top: 0;
        height: 100vh;
    }
}

/* --- Mobile : offcanvas plus moderne --- */
@media (max-width: 991.98px) {
    .sidebar.offcanvas-lg {
        width: min(280px, 82vw);
        /* border-top-right-radius: 20px;
        border-bottom-right-radius: 20px; */
        box-shadow: 8px 0 40px rgba(0, 0, 0, 0.35);
    }
}

.offcanvas-backdrop {
    backdrop-filter: blur(2px);
}

/* --- Logo --- */
.sidebar .offcanvas-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;
    padding: 1.1rem 1.25rem;
}

.sidebar-logo {
    height: 30px;
    width: auto;
    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, .25));
}

/* --- Profil utilisateur --- */
.sidebar .offcanvas-body>.d-flex {
    border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;
    background: rgba(255, 255, 255, 0.02);
}

.sidebar-avatar {
    width: 44px;
    height: 44px;
    object-fit: cover;
    border: 2px solid var(--bs-primary);
    box-shadow: 0 0 0 3px rgba(47, 111, 235, 0.15);
    flex-shrink: 0;
}

.sidebar h6.text-truncate {
    color: #fff;
    font-weight: 600;
}

.sidebar-status {
    color: #94a3b8;
}

.online_animation {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--brand-live);
    display: inline-block;
    animation: online-pulse 2s infinite;
}

@keyframes online-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(22, 199, 154, .5);
    }

    70% {
        box-shadow: 0 0 0 5px rgba(22, 199, 154, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(22, 199, 154, 0);
    }
}

/* --- Navigation --- */
.sidebar .nav {
    padding: 1rem .75rem !important;
}

.sidebar .nav-link {
    position: relative;
    color: #c3cddb;
    border-radius: 12px;
    padding: .7rem .9rem;
    font-weight: 500;
    font-size: .92rem;
    transition: background .18s ease, color .18s ease, transform .15s ease;
}

.sidebar .nav-link span {
    color: inherit;
}

.sidebar .nav-link:hover {
    background: rgba(255, 255, 255, 0.06);
    color: #fff;
    transform: translateX(3px);
}

.sidebar .nav-link.active {
    background: linear-gradient(135deg, var(--bs-primary), #4f8cff);
    color: #fff;
    box-shadow: 0 6px 16px rgba(47, 111, 235, 0.35);
}

/* Barre d'accent à gauche du lien actif */
.sidebar .nav-link.active::before {
    content: "";
    position: absolute;
    left: -.75rem;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 60%;
    border-radius: 0 4px 4px 0;
    background: #fff;
    opacity: .85;
}

.sidebar .nav-link.active i,
.sidebar .nav-link.active .orange_color {
    color: #fff;
}

.orange_color {
    width: 18px;
    text-align: center;
    color: #6aa8ff;
    transition: color .18s ease;
}

/* Bouton déconnexion */
.sidebar .nav-link.text-start.bg-transparent {
    color: #ff8a8a;
    margin-top: .5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 0;
    padding-top: 1rem;
}

.sidebar .nav-link.text-start.bg-transparent:hover {
    background: rgba(255, 90, 90, 0.1);
    color: #ffb3b3;
    transform: none;
}

/* Scrollbar custom pour la nav */
.sidebar .offcanvas-body ul.nav {
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
}

.sidebar .offcanvas-body ul.nav::-webkit-scrollbar {
    width: 5px;
}

.sidebar .offcanvas-body ul.nav::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 10px;
}

/* Badge alerte */
.sidebar .badge.bg-danger {
    font-size: .68rem;
    padding: .3em .5em;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/sidebar.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,+BAA+B;IAC/B,+BAA+B;IAC/B,0EAA0E;IAC1E,iDAAiD;AACrD;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN,aAAa;IACjB;AACJ;;AAEA,4CAA4C;AAC5C;IACI;QACI,uBAAuB;QACvB;2CACmC;QACnC,0CAA0C;IAC9C;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;IACI,6DAA6D;IAC7D,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iDAAiD;AACrD;;AAEA,+BAA+B;AAC/B;IACI,6DAA6D;IAC7D,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mCAAmC;IACnC,8CAA8C;IAC9C,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI;QACI,0CAA0C;IAC9C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,yCAAyC;IAC7C;AACJ;;AAEA,uBAAuB;AACvB;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,sEAAsE;AAC1E;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,+DAA+D;IAC/D,WAAW;IACX,+CAA+C;AACnD;;AAEA,0CAA0C;AAC1C;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,2BAA2B;AAC/B;;AAEA,uBAAuB;AACvB;IACI,cAAc;IACd,iBAAiB;IACjB,+CAA+C;IAC/C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,qBAAqB;IACrB,sDAAsD;AAC1D;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".sidebar {\n    flex: 0 0 var(--sidebar-width);\n    width: var(--sidebar-width);\n    min-width: var(--sidebar-width);\n    max-width: var(--sidebar-width);\n    background: linear-gradient(180deg, #0f2036 0%, #15283c 60%, #17324e 100%);\n    border-right: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n@media (min-width: 992px) {\n    .sidebar {\n        position: sticky;\n        top: 0;\n        height: 100vh;\n    }\n}\n\n/* --- Mobile : offcanvas plus moderne --- */\n@media (max-width: 991.98px) {\n    .sidebar.offcanvas-lg {\n        width: min(280px, 82vw);\n        /* border-top-right-radius: 20px;\n        border-bottom-right-radius: 20px; */\n        box-shadow: 8px 0 40px rgba(0, 0, 0, 0.35);\n    }\n}\n\n.offcanvas-backdrop {\n    backdrop-filter: blur(2px);\n}\n\n/* --- Logo --- */\n.sidebar .offcanvas-header {\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;\n    padding: 1.1rem 1.25rem;\n}\n\n.sidebar-logo {\n    height: 30px;\n    width: auto;\n    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, .25));\n}\n\n/* --- Profil utilisateur --- */\n.sidebar .offcanvas-body>.d-flex {\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;\n    background: rgba(255, 255, 255, 0.02);\n}\n\n.sidebar-avatar {\n    width: 44px;\n    height: 44px;\n    object-fit: cover;\n    border: 2px solid var(--bs-primary);\n    box-shadow: 0 0 0 3px rgba(47, 111, 235, 0.15);\n    flex-shrink: 0;\n}\n\n.sidebar h6.text-truncate {\n    color: #fff;\n    font-weight: 600;\n}\n\n.sidebar-status {\n    color: #94a3b8;\n}\n\n.online_animation {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: var(--brand-live);\n    display: inline-block;\n    animation: online-pulse 2s infinite;\n}\n\n@keyframes online-pulse {\n    0% {\n        box-shadow: 0 0 0 0 rgba(22, 199, 154, .5);\n    }\n\n    70% {\n        box-shadow: 0 0 0 5px rgba(22, 199, 154, 0);\n    }\n\n    100% {\n        box-shadow: 0 0 0 0 rgba(22, 199, 154, 0);\n    }\n}\n\n/* --- Navigation --- */\n.sidebar .nav {\n    padding: 1rem .75rem !important;\n}\n\n.sidebar .nav-link {\n    position: relative;\n    color: #c3cddb;\n    border-radius: 12px;\n    padding: .7rem .9rem;\n    font-weight: 500;\n    font-size: .92rem;\n    transition: background .18s ease, color .18s ease, transform .15s ease;\n}\n\n.sidebar .nav-link span {\n    color: inherit;\n}\n\n.sidebar .nav-link:hover {\n    background: rgba(255, 255, 255, 0.06);\n    color: #fff;\n    transform: translateX(3px);\n}\n\n.sidebar .nav-link.active {\n    background: linear-gradient(135deg, var(--bs-primary), #4f8cff);\n    color: #fff;\n    box-shadow: 0 6px 16px rgba(47, 111, 235, 0.35);\n}\n\n/* Barre d'accent à gauche du lien actif */\n.sidebar .nav-link.active::before {\n    content: \"\";\n    position: absolute;\n    left: -.75rem;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 4px;\n    height: 60%;\n    border-radius: 0 4px 4px 0;\n    background: #fff;\n    opacity: .85;\n}\n\n.sidebar .nav-link.active i,\n.sidebar .nav-link.active .orange_color {\n    color: #fff;\n}\n\n.orange_color {\n    width: 18px;\n    text-align: center;\n    color: #6aa8ff;\n    transition: color .18s ease;\n}\n\n/* Bouton déconnexion */\n.sidebar .nav-link.text-start.bg-transparent {\n    color: #ff8a8a;\n    margin-top: .5rem;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 0;\n    padding-top: 1rem;\n}\n\n.sidebar .nav-link.text-start.bg-transparent:hover {\n    background: rgba(255, 90, 90, 0.1);\n    color: #ffb3b3;\n    transform: none;\n}\n\n/* Scrollbar custom pour la nav */\n.sidebar .offcanvas-body ul.nav {\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.15) transparent;\n}\n\n.sidebar .offcanvas-body ul.nav::-webkit-scrollbar {\n    width: 5px;\n}\n\n.sidebar .offcanvas-body ul.nav::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.15);\n    border-radius: 10px;\n}\n\n/* Badge alerte */\n.sidebar .badge.bg-danger {\n    font-size: .68rem;\n    padding: .3em .5em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
